// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import swal from 'sweetalert'

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  // console.log(`Error: ${err.toString()}\nInfo: ${info}`)
  // console.log(JSON.stringify(err, null, 2))
  // Identifica la expiracion del token
  if (err.name === 'TokenExpiredError') {
    swal({
      title: 'Sesión Expirada',
      text: 'Su sesión expiró y debe de ingresar de nuevo'
    })
      .then(() => {
        location.href = '/' + localStorage.getItem('subnet') + '/login'
      })
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js